import { useState, useRef, useEffect } from "react";

interface CardProps {
    title?: string;
    content?: string | string[];
}

const Card = ({ title, content: initialContent }: CardProps) => {
    const [isEditing, setIsEditing] = useState(false);
    const [content, setContent] = useState(initialContent);
    const [previousContent, setPreviousContent] = useState(initialContent);
    const textareaRef = useRef<HTMLTextAreaElement>(null);

    // const handleEdit = () => {
    //     setPreviousContent(content);
    //     setIsEditing(true);
    // };

    const handleContentChange = (event: React.ChangeEvent<HTMLTextAreaElement>) => {
        setContent(event.target.value.split("\n"));
    };

    // const handleSave = (event: React.MouseEvent) => {
    //     event.stopPropagation();
    //     setIsEditing(false);
    // };

    const handleCancel = (event: React.MouseEvent) => {
        event.stopPropagation();
        setContent(previousContent);
        setIsEditing(false);
    };

    useEffect(() => {
        if (isEditing && textareaRef.current) {
            textareaRef.current.style.height = 'auto';
            textareaRef.current.style.minHeight = `${textareaRef.current.scrollHeight}px`;
            textareaRef.current.focus();
        }
    }, [isEditing, content]);

    return (
        <div className="card-component bg-white text-black mt-4 p-4 rounded-lg transition-transform w-full  sm:w-8/10 relative shadow-lg">
            <h2 className="component-title text-green-800 font-bold">{title}</h2>
            <div className="component-content">
                {Array.isArray(content) ? (
                    isEditing ? (
                        <textarea className="w-11/12 p-2" ref={textareaRef} value={content.map(item => `• ${item}`).join("\n")} onChange={handleContentChange} />
                    ) : (
                        <ul className="list-disc mx-6 p-2 leading-relaxed">
                            {content.map((item, index) => (
                                <li key={index}>{item}</li>
                            ))}
                        </ul>
                    )
                ) : typeof content === "string" ? (
                    <p>{content}</p>
                ) : (
                    <div className="empty-box"></div>
                )}
            </div>
        </div>
    );
};

export default Card;
